import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=6664137d"
import script from "./DropdownItem.vue?vue&type=script&lang=ts"
export * from "./DropdownItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports